import { FC, PropsWithChildren } from 'react';
import { RosterOptionsProvider, useSelectedRoster } from './RosterOptionsService';
import { WorkingRosterProvider } from './WorkingRosterService';
import { RosterWarningsProvider } from './RosterWarningsService';

const RosterProviderInner: FC<PropsWithChildren> = ({ children }) => {
  const roster = useSelectedRoster();
  const key = `${roster?.id}-${roster?.lastModified}`;

  return (
    <WorkingRosterProvider key={key}>
      <RosterWarningsProvider>{children}</RosterWarningsProvider>
    </WorkingRosterProvider>
  );
};

interface RosterProviderProps extends PropsWithChildren {
  date: Date;
}

export const RosterProvider: FC<RosterProviderProps> = ({ children, date }) => {
  return (
    <RosterOptionsProvider date={date}>
      <RosterProviderInner>{children}</RosterProviderInner>
    </RosterOptionsProvider>
  );
};
